export default __webpack_public_path__ + "static/trackthebat5-2d851f17d3eb70645863616ff8220d60.png";